
class agentRegister {

    static profile = null;

    static set(profile){
        agentRegister.profile = profile;
        try {
            sessionStorage.setItem('agent_profile', JSON.stringify(profile));
        }catch (e) {}
    }

    static get(){
        try {
            if(sessionStorage.getItem('agent_profile')){
                return JSON.parse(sessionStorage.getItem('agent_profile'));
            }else{
                return agentRegister.profile;
            }
        }catch (e) {
            return agentRegister.profile;
        }
    }

    static remove(){
        agentRegister.profile = null;
        try {
            sessionStorage.removeItem('agent_profile');
        }catch (e) {}
    }
}

export {agentRegister}


// WEBPACK FOOTER //
// ./src/services/agentRegister.js